import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';

import type { AttendContactLeaveEarlyJson } from '@/types/domain/attendContact/entities/attendContactLeaveEarlyEntity';

import DialogTitle from '@/components/DialogTitle';
import DialogTransition from '@/components/DialogTransition';
import LeaveEarlyInfo from '@/domain/attendContact/component/LeaveEarlyInfo';

/**
 * 入力
 */
export type DeleteLeaveEarlyInput = {
  /** データ */
  data: AttendContactLeaveEarlyJson | undefined,
  /** 閉じる */
  close: (v: AttendContactLeaveEarlyJson | undefined) => void,
}

const DeleteLeaveEarly: React.FC<DeleteLeaveEarlyInput> = ({ data, close }) => (
  <Dialog
    open={data !== undefined}
    onClose={() => close(undefined)}
    fullScreen
    TransitionComponent={DialogTransition}
  >
    <DialogTitle title="早退連絡" />
    <DialogContent>
      {data && <LeaveEarlyInfo data={data} />}
    </DialogContent>
    <DialogActions>
      <Button variant="contained" onClick={() => close(data)} color="primary">
        取り消す
      </Button>
      <Button variant="contained" onClick={() => close(undefined)} color="primary">
        閉じる
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteLeaveEarly;
